import { mapGetters } from "vuex"
import Config from '@/thirdParty/config'
export default {
  data () {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      Config
    }
  },
  mounted () {
    this.$root.$on('bv::modal::hide', bvEvent => {
      if (bvEvent.componentId === 'rejectMx' && bvEvent.trigger === 'ok' && this.$refs.rejectValue) {
        if (!this.$refs.rejectValue.value.trim()) {
          this.showFailMx('Lý do nhập không được bỏ trống', false)
          bvEvent.preventDefault()
        }
      }
    })
    this.$root.$on('bv::modal::hide', bvEvent => {
      if (bvEvent.componentId === 'rejectDeviceMx' && bvEvent.trigger === 'ok' && this.$refs.rejectValue) {
        if (!this.$refs.rejectValue.value.trim()) {
          this.showFailMx('Lý do thất lạc không được bỏ trống', false)
          bvEvent.preventDefault()
        } else if (this.$refs.rejectValue.value.trim().length > 1000) {
          this.showFailMx('Lý do thất lạc chứa tối đa 1000 ký tự', false)
          bvEvent.preventDefault()
        }
      }
    })
  },
  computed: {
    ...mapGetters({
      dataPermission: 'role/dataPermission',
    })
  },
  methods: {
    canAccessMx(...roles) {
      return !!roles.find(role => this.dataPermission.includes(role))
    },
    approveMx (message) {
      const h = this.$createElement
      const messageVNode = h(
        'p',
        { class: 'f14' },
        message
      )
      return this.$bvModal
        .msgBoxConfirm([messageVNode], {
          title: 'Lưu ý',
          okTitle: 'Xác nhận',
          cancelTitle: 'Huỷ',
          centered: true
        })
    },
    rejectMx (title = 'Lý do từ chối', value = '') {
      const h = this.$createElement
      const messageVNode = h('div', { class: 'form-group pos-relative' }, [
        h('textarea', { ref: 'rejectValue', class: 'form-control f12' , domProps: { value }})
      ])
      return this.$bvModal
        .msgBoxConfirm([messageVNode], {
          id: 'rejectMx',
          title: title,
          okTitle: 'Xác nhận',
          cancelTitle: 'Huỷ',
          centered: true,
          okDisabled: false
        })
        .then(async value => {
          return {
            value,
            note: this.$refs.rejectValue.value
          }
        })
    },
    rejectDeviceMx (title = 'Lý do từ chối') {
      const h = this.$createElement
      const messageVNode = h('div', { class: 'form-group pos-relative' }, [
        h('textarea', { ref: 'rejectValue', class: 'form-control f12' })
      ])
      return this.$bvModal
        .msgBoxConfirm([messageVNode], {
          id: 'rejectDeviceMx',
          title: title,
          okTitle: 'Xác nhận',
          cancelTitle: 'Huỷ',
          centered: true,
          okDisabled: false
        })
        .then(async value => {
          return {
            value,
            note: this.$refs.rejectValue.value
          }
        })
    },
    showMsgMx (msgNoti, flag, createElement) {
      const h = this.$createElement
      const titleVNode = h('div', {
        domProps: { innerHTML: 'Thông báo' }
      })
      const messageVNode = h('div', { class: ['text-center'] }, [
        h('b-img', {
          props: {
            src: require(flag === true ? '@/assets/img/noti-success2.svg' : '@/assets/img/noti-unsuccess2.svg')
          }
        }),
        createElement
            ? h('div', { class: ['text-break f18 py-3 text-center'] }, [msgNoti, createElement])
            : h('div', { class: ['text-break f18 py-3 text-center'], domProps: { innerHTML: msgNoti } })
      ])
      return {
        titleVNode,
        messageVNode
      }
    },
    showSuccessMx (msgNoti, createElement = null ) {
      const { titleVNode, messageVNode } = this.showMsgMx(msgNoti, true, createElement )
      return this.$bvModal.msgBoxOk([messageVNode], {
        title: [titleVNode],
        centered: true,
        okTitle: 'Đóng',
        okVariant: 'light'
      })
    },
    showToastError(msg) {
      return this.$bvToast.toast(msg ?? 'Có lỗi xảy ra', {
        title: 'Oops!!',
        autoHideDelay: 5 * 60 * 60,
        variant: 'danger',
        toaster: 'b-toaster-top-right',
        solid: true,
        appendToast: true
      })
    },
    showToastSuccess(msg) {
      return this.$bvToast.toast(msg ?? 'Thành công', {
        title: 'Thông báo',
        autoHideDelay: 5 * 60 * 60,
        variant: 'success',
        toaster: 'b-toaster-top-right',
        solid: true,
        appendToast: true
      })
    },
    showFailMx (msgNoti, createElement = null) {
      const { titleVNode, messageVNode } = this.showMsgMx(msgNoti, false, createElement)
      return this.$bvModal.msgBoxOk([messageVNode], {
        title: [titleVNode],
        centered: true,
        okTitle: 'Đóng',
        okVariant: 'light'
      })
    },
    showModalComponentMx (title, cpn) {
      const component = this.$createElement(cpn.name, { props: cpn.props });
      return this.$bvModal.msgBoxOk([component], {
        title,
        id: cpn.id,
        centered: true,
        size: cpn.size ?? 'lg',
        hideFooter: true,
        footerClass: cpn.footerClass ?? '',
        ignoreEnforceFocusSelector: 'input'
      })
    },
    requestAdditionalOptionMx(optionAdditional, value = '') {
      const h = this.$createElement;
      let noteValue = value;
      let selectedValue = [];

      const messageVNode = h('div', { class: 'form-group pos-relative' }, [
        h('textarea', {
          ref: 'noteValue',
          class: 'form-control f12 mb-2',
          domProps: { value: noteValue },
          on: {
            input: (event) => {
              noteValue = event.target.value;
            }
          }
        }),
        h('select2-multiple-control', {
          ref: '',
          props: {
            value: selectedValue,
            options: optionAdditional,
            settings: {
              placeholder: 'Chọn lý do cần bổ sung'
            }
          },
          on: {
            change: (values) => {
              selectedValue = values;
            }
          }
        },
      )
      ]);

      return this.$bvModal
        .msgBoxConfirm([messageVNode], {
          id: 'rejectMx',
          title: "Lý do cần bổ sung",
          okTitle: 'Xác nhận',
          cancelTitle: 'Huỷ',
          centered: true,
          okDisabled: false
        })
        .then(value => {
          return {
            value,
            note: noteValue,
            noteReason: selectedValue
          };
        });
    },


  }
}
